import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useImportOrganizationsFromWhitelist = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (id) => authAPI.importOrganizationsFromWhitelist(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["feideWhitelists"]);
        queryClient.invalidateQueries(["organizations"]);
      },
    }
  );
};
